import { render, staticRenderFns } from "./disposeDialog.vue?vue&type=template&id=765b5400&scoped=true&"
import script from "./disposeDialog.vue?vue&type=script&lang=js&"
export * from "./disposeDialog.vue?vue&type=script&lang=js&"
import style0 from "./disposeDialog.vue?vue&type=style&index=0&id=765b5400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b5400",
  null
  
)

export default component.exports